import { render, staticRenderFns } from "./HistoryYear.vue?vue&type=template&id=538c7fa8"
import script from "./HistoryYear.vue?vue&type=script&lang=js"
export * from "./HistoryYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports